<template lang="html">
    <div class="page-title">
        <div class="container">
            <div class="page-title-layout">
                <div>
                    <span v-if="iconClass" class="icon" :class="iconClass"></span>
                    <h1>{{title}}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2';

export default {
    components: {
        NsLoader
    },
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        },
        simulationIndicator: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            simulationsTotal: 0,
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        toLoad() {
            return [
                {
                    model: 'simulationsTotal',
                    name: 'simulationsTotal',
                    stats: true,
                    filters: {
                        //user_uid: this.currentUser.uid
                    }
                }
            ]
        },
        iconClass() {
            return (this.icon) ? 'icon-' + this.icon : false;
        }
    },
    methods: {
        onDataFetched(data) {
            this.simulationsTotal = data.simulationsTotal
        }
    }
};
</script>

<style lang="less">
@import '../../less/variables';

.page-title {
    display: block;
    position: relative;
    background-color: @color-1;

    .page-title-layout{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .loading-simulations{
        color: #1b224b;
        font-size: 30px;
    }
    .icon-bin {
        display: block;
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 30px;
        transform: translate(0,-50%);
        color: @color-text;
        opacity: .6;
        cursor: pointer;
        transition: opacity .2s ease-in-out;
        &:hover {
            opacity: 1;
        }
    }
    .icon {
        display: inline-block;
        vertical-align: middle;
        font-size: 50px;
        margin-right: 20px;
        margin-top: 10px;
        margin-bottom: 10px;
        color: white;
    }
    h1 {
        display: inline-block;
        vertical-align: middle;
        color: white;
        font-size: 30px;
        line-height: 30px;
        margin-top: 20px;
    }
    .simulationIndicator {
        float: right;
        height: 50px;
        width: auto;
        font-size: 30px;
        border-radius: 50px;
        padding: 11px 10px 0;
        margin: 10px 0 0 0;
        text-align: center;
        background-color: #27316D;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/page-title.vue